import { Fragment, useEffect } from 'react';
import {useDispatch, useSelector} from 'shared/hooks';
import analytics from 'shared/utility/analytics';
import {Heading, LabelText} from 'shared/components';
import {sync, SYNC} from 'shared/wizard/actions';
import {Input} from "shared/inputs";

const LeadInformationForm = () => {
  const dispatch = useDispatch();
  const {
    input: {
      first_name,
      last_name_prefix,
      last_name,
      email,
      phone_number,
      postal_code,
      house_number,
      house_number_addition
    },
    output: {
        errors
    },
    settings = null
  } = useSelector(state => state);

  const leadAddressInformation = settings?.leadAddressInformation ?? false;

  useEffect(() => {
    dispatch({type: SYNC, syncing: false, recalculate: null});
    analytics.send('Bereken', 'Resultaat');
  }, []);

  return (
      <Fragment>
          <Heading>Contact gegevens</Heading>

          <LabelText>Voornaam</LabelText>
          <Input
              name="first_name"
              value={first_name || ''}
              onChange={sync(dispatch)('first_name')}
              errors={errors?.first_name}
              placeholder="Voornaam"
              type="text"
              label={`Voornaam`}
          />

          <LabelText>Tussenvoegsel(s)</LabelText>
          <Input
              name="last_name_prefix"
              value={last_name_prefix || ''}
              onChange={sync(dispatch)('last_name_prefix')}
              errors={errors?.last_name_prefix}
              placeholder="Tussenvoegsel(s)"
              type="text"
              label={`Tussenvoegsel(s)`}
          />

          <LabelText>Achternaam</LabelText>
          <Input
              name="last_name"
              value={last_name || ''}
              onChange={sync(dispatch)('last_name')}
              errors={errors?.last_name}
              placeholder="Achternaam"
              type="text"
              label={`Achternaam`}
          />

          <LabelText>E-mailadres</LabelText>
          <Input
              name="email"
              value={email || ''}
              onChange={sync(dispatch)('email')}
              errors={errors?.email}
              placeholder="Email"
              type="email"
              label={`Email`}
          />

          <LabelText>Telefoonnummer</LabelText>
          <Input
              name="phone_number"
              value={phone_number || ''}
              onChange={sync(dispatch)('phone_number')}
              placeholder="06123456789"
              errors={errors?.phone_number}
          />

          {leadAddressInformation ? (
              <>
                  <LabelText>Postcode</LabelText>
                  <Input
                      name="postal_code"
                      value={postal_code || ''}
                      onChange={sync(dispatch)('postal_code')}
                      placeholder="12345AB"
                      errors={errors?.postal_code}
                  />

                  <LabelText>Huisnummer</LabelText>
                  <Input
                      name="house_number"
                      value={house_number || ''}
                      onChange={sync(dispatch)('house_number')}
                      placeholder="123"
                      errors={errors?.house_number}
                  />

                  <LabelText>Toevoeging</LabelText>
                  <Input
                      name="house_number_addition"
                      value={house_number_addition || ''}
                      onChange={sync(dispatch)('house_number_addition')}
                      placeholder="A"
                      errors={errors?.house_number_addition}
                  />
              </>
          ) : (<></>)}
      </Fragment>
  );
};

export default LeadInformationForm;
